import React, { ReactElement, useState } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import MotherIcon from 'src/v3/core/mother-icon'
import SessionList from './SessionList'
import SessionDetail from './SessionDetail'

export default (): ReactElement => {
  let [selectedSession, setSelectedSession] = useState<string | null>(null)

  return (
    <Box
      sx={{
        height: { xs: 'auto', md: '100vh' },
        bgcolor: 'background.default',
        p: { xs: 1, sm: 2 },
      }}
    >
      {/* Header */}
      <Box sx={{ mb: { xs: 2, md: 3 } }}>
        <Typography
          variant="h4"
          sx={{ fontSize: { xs: '1.5rem', md: '2.125rem' } }}
        >
          <MotherIcon sx={{ mr: 1 }} />
          MOTHER Audit Explorer
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Monitor and analyze agentic AI session execution
        </Typography>
      </Box>

      {/* Main Content */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          gap: 2,
          height: { xs: 'auto', md: 'calc(100vh - 140px)' },
        }}
        role="main"
      >
        {/* Session List - Left Panel */}
        <Paper
          sx={{
            width: { xs: '100%', md: '35%' },
            p: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            maxHeight: { xs: '50vh', sm: '60vh', md: 'none' },
            minHeight: { xs: '250px', md: 'auto' },
          }}
          role="navigation"
          aria-label="Sessions list"
        >
          <SessionList
            selectedSession={selectedSession}
            onSessionSelect={setSelectedSession}
          />
        </Paper>

        {/* Session Details - Right Panel */}
        <Paper
          sx={{
            flex: 1,
            p: 2,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            minHeight: { xs: '400px', md: 'auto' },
          }}
        >
          <SessionDetail selectedSession={selectedSession} />
        </Paper>
      </Box>
    </Box>
  )
}
